const Chip = ({ color = "gray", children, muted = false, onClick = () => {}, className="cursor-pointer", active=false}) => {
    const colors = {
        gray: "bg-gray-100 text-gray-800",
        red: "bg-red-100 text-red-700",
        green: "bg-green-100 text-green-700",
        blue: "bg-blue-100 text-blue-700",
        yellow: "bg-yellow-100 text-yellow-700",
        orange: "bg-orange-100 text-orange-700",
        violet: "bg-violet-100 text-violet-700",
        neutral: "bg-gray-50 text-gray-700 border border-gray-200",
        pink: "bg-pink-200 text-pink-700",
        teal: "bg-teal-200 text-teal-700",
        indigo: "bg-indigo-200 text-indigo-700",
        sky: "bg-sky-200 text-sky-700",
        lime: "bg-lime-200 text-lime-700"
    };
    const borderColors = {
        gray: "border border-gray-200",
        red: "border border-red-200",
        green: "border border-green-200",
        blue: "border border-blue-200",
        yellow: "border border-yellow-200",
        orange: "border border-orange-200",
        violet: "border border-violet-200",
        neutral: "border border-gray-200",
        pink: "border border-pink-200",
        teal: "border border-teal-200",
        indigo: "border border-indigo-200",
        sky: "border border-sky-200",
        lime: "border border-lime-200"
    };
    const base = `inline-flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-full border border-transparent ${colors[color] || colors.gray} ${active && borderColors[color]}`;
    return <span className={`${muted ? `${base} opacity-70` : base} ${className}`} onClick={onClick}>{children}</span>;
};

export default Chip;